const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  if (window.location.hostname === 'construction-erp.oleocotech.com') {
    return 'https://construction-erp.oleocotech.com';
  }
  return 'http://localhost:8080';
};

const API_BASE_URL = getApiBaseUrl();

export const config = {
  apiBaseUrl: API_BASE_URL,
  clientApiUrl: `${API_BASE_URL}/api/v1`,
  superAdminApiUrl: `${API_BASE_URL}/api`,
};

export default config;
